'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IsolateModule = exports.IsolateModule = function () {
  function IsolateModule(isolatedElements) {
    _classCallCheck(this, IsolateModule);

    this.isolatedElements = isolatedElements;
    this.eventDelegators = new Map([]);
  }

  _createClass(IsolateModule, [{
    key: 'setScope',
    value: function setScope(elm, scope) {
      this.isolatedElements.set(scope, elm);
    }
  }, {
    key: 'removeScope',
    value: function removeScope(scope) {
      this.isolatedElements.delete(scope);
    }
  }, {
    key: 'getIsolatedElement',
    value: function getIsolatedElement(scope) {
      return this.isolatedElements.get(scope);
    }
  }, {
    key: 'isIsolatedElement',
    value: function isIsolatedElement(elm) {
      var elements = Array.from(this.isolatedElements.entries());

      for (var i = 0; i < elements.length; ++i) {
        if (elm === elements[i][1]) {
          return elements[i][0];
        }
      }
      return false;
    }
  }, {
    key: 'addEventDelegator',
    value: function addEventDelegator(scope, eventDelegator) {
      var delegators = this.eventDelegators.get(scope);
      if (!delegators) {
        delegators = [];
        this.eventDelegators.set(scope, delegators);
      }
      delegators[delegators.length] = eventDelegator;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.isolatedElements.clear();
    }
  }, {
    key: 'createModule',
    value: function createModule() {
      var self = this;
      return {
        create: function create(oldVNode, vNode) {
          // eslint-disable-line complexity
          var _oldVNode$data = oldVNode.data;
          var oldData = _oldVNode$data === undefined ? {} : _oldVNode$data;
          var elm = vNode.elm;
          var _vNode$data = vNode.data;
          var data = _vNode$data === undefined ? {} : _vNode$data;

          var oldScope = oldData.isolate || '';
          var scope = data.isolate || '';
          if (scope) {
            if (oldScope) {
              self.removeScope(oldScope);
            }
            self.setScope(elm, scope);
            var delegators = self.eventDelegators.get(scope);
            if (delegators) {
              for (var i = 0, len = delegators.length; i < len; ++i) {
                delegators[i].updateTopElement(elm);
              }
            } else if (delegators === void 0) {
              self.eventDelegators.set(scope, []);
            }
          }
          if (oldScope && !scope) {
            self.removeScope(scope);
          }
        },
        update: function update(oldVNode, vNode) {
          // eslint-disable-line complexity
          var _oldVNode$data2 = oldVNode.data;
          var oldData = _oldVNode$data2 === undefined ? {} : _oldVNode$data2;
          var elm = vNode.elm;
          var _vNode$data2 = vNode.data;
          var data = _vNode$data2 === undefined ? {} : _vNode$data2;

          var oldScope = oldData.isolate || '';
          var scope = data.isolate || '';
          if (scope) {
            if (oldScope) {
              self.removeScope(oldScope);
            }
            self.setScope(elm, scope);
          }
          if (oldScope && !scope) {
            self.removeScope(scope);
          }
        },
        remove: function remove(_ref, cb) {
          var _ref$data = _ref.data;
          var data = _ref$data === undefined ? {} : _ref$data;

          var scope = data.isolate;
          if (scope) {
            self.removeScope(scope);
            if (self.eventDelegators.get(scope)) {
              self.eventDelegators.set(scope, []);
            }
          }
          cb();
        },
        destroy: function destroy(_ref2) {
          var _ref2$data = _ref2.data;
          var data = _ref2$data === undefined ? {} : _ref2$data;

          var scope = data.isolate;
          if (scope) {
            self.removeScope(scope);
            if (self.eventDelegators.get(scope)) {
              self.eventDelegators.set(scope, []);
            }
          }
        }
      };
    }
  }]);

  return IsolateModule;
}();


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/isolate/module.js
 **/